/* global L */

class CustomMap extends HTMLElement {
  connectedCallback() {
    this.insertAdjacentHTML('beforeend', '<rentals-map class="vh-100 d-flex bg-dark bg-opacity-10" data-layer-type><div class="m-auto spinner-border text-primary" role="status"></div></rentals-map>');
    this.querySelector('rentals-map').addEventListener('rentals-map:leaflet:init', () => {
      const { map } = document.querySelector('rentals-map');
      const { markers, showMarker } = this.dataset;

      if (markers) {
        const parsedMarkers = JSON.parse(markers);
        const markersCoordinates = [];

        if (showMarker) {
          Object.keys(parsedMarkers).forEach((key) => {
            if (key !== showMarker) {
              delete parsedMarkers[key];
            }
          });
        }

        console.log(parsedMarkers);

        // loop through markers object keys
        Object.keys(parsedMarkers).forEach((key) => {
          const marker = parsedMarkers[key];

          markersCoordinates.push([marker.lat, marker.lng]);

          L.marker(
            [marker.lat, marker.lng],
            {
              icon: L.dataDivIcon({
                html: `
                  <div class="bottom-100 card mb-5 position-absolute start-50 translate-middle-x shadow transition-base">
                    <img src="/assets/themes/2205/images/${marker.img}" class="card-img-top" alt="${marker.title}">
                    <div class="card-body">
                      <h5 class="card-title text-black">${marker.title}</h5>
                      <p class="card-text">${marker.address}</p>
                      <a href="${marker.link}" target="_blank" class="link-primary">${this.dataset.tLinkLabel}</a>
                    </div>
                  </div>
                  <div data-marker-pin class="overflow-hidden position-absolute rounded-2 shadow start-50 text-black top-50 transition-base translate-middle">
                    <img src="/assets/themes/2205/images/nonante-neuf_logo.jpg" height="50" alt="nonante neuf">
                  </div>
                `,
                data: {
                  lat: marker.lat,
                  lng: marker.lng,
                },
              }),
            },
          ).addTo(map);
        });

        if (showMarker) {
          map.setView(markersCoordinates[0], 15);
        } else {
          map.fitBounds(markersCoordinates, { padding: [50, 50] });

          // set marker .card hidden by default
          const cards = document.querySelectorAll('.card');
          cards.forEach((card) => {
            card.classList.add('opacity-0', 'visually-hidden');
          });

          // set marker .card visible on click on marker pin and hide others
          const markerPins = document.querySelectorAll('[data-marker-pin]');
          markerPins.forEach((markerPin) => {
            markerPin.addEventListener('click', () => {
              cards.forEach((card) => {
                card.classList.add('opacity-0', 'visually-hidden');
              });

              markerPin.previousElementSibling.classList.remove('opacity-0', 'visually-hidden');

              // center map on marker
              map.setView([
                markerPin.parentElement.dataset.lat,
                markerPin.parentElement.dataset.lng,
              ], map.getZoom());
            });
          });
        }
      }
    });
  }
}

customElements.define('custom-map', CustomMap);
